<template>
    <div>
        <h1 class="mx-auto col-11" v-if="code !== null && code !== undefined">Désolé ...</h1>

        <div v-else-if="loaded" class="mx-auto col-11 d-flex justify-content-between">
            <div>
                <h4 style="color: gray">{{ provider.name }}</h4>
                <h1 v-if="aspect !== null">Mes informations -
                    <span v-if="aspect === 'business'">Tourisme d'Affaires 💼</span>
                    <span v-else-if="aspect === 'winter'">Hiver ❄️</span>
                    <span v-else-if="aspect === 'summer'">Eté 🔆</span>
                </h1>
                <h1 v-else-if="formTitle === null || formTitle === undefined || formTitle.value === null">Formulaire de validation de vos informations</h1>
                <h1 v-else>{{formTitle.value }}</h1>
            </div>
            <div class="logo ml-3">
                <v-img height="100px" max-width="300px" position="right" contain :src="logo.doc_url"></v-img>
            </div>
        </div>

        <div v-else class="mx-auto col-11">
            <content-placeholders class="d-flex justify-content-between">
                <content-placeholders-heading class="place-holder-title-xs" style="width: 400px; height: 51px"/>
                <content-placeholders-img class="place-holder-title-lg ml-3" style="width: 150px; height: 80px">
                </content-placeholders-img>
            </content-placeholders>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex"

export default {
    name: "CmajFormHeader",
    props: ['code', 'loaded', 'formTitle', 'logo'],
    computed: {
        ...mapState('web_form', ['provider', 'aspect'])
    }
}
</script>